import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { SimCard } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const ESIMOrdersEmpty = () => {
  const { t } = useTranslation();

  return (
    <Box mt={4}>
      <Typography variant="h6" gutterBottom>
        {t("esim.orders.yourESIMs")}
      </Typography>
      <Paper sx={{ p: 3, textAlign: "center" }}>
        <SimCard sx={{ fontSize: 48, color: "text.secondary", mb: 2 }} />
        <Typography color="textSecondary">
          {t("esim.orders.noOrders")}
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
          {t("esim.orders.purchaseToStart")}
        </Typography>
      </Paper>
    </Box>
  );
};

export default ESIMOrdersEmpty;
